/**
 * The sign-in gate.
 *
 * Deliberately plain. There is one action, no branding beyond the product name, and no
 * explanation of what the tool does - somebody arriving here already knows, and a marketing
 * page in front of an internal tool is a page people learn to click past without reading.
 */

export interface SignInProps {
  /**
   * Present when a previous attempt failed, in Entra's own words. Explicitly `| undefined`
   * because the workspace sets exactOptionalPropertyTypes, which distinguishes an absent
   * property from one present and undefined.
   */
  readonly reason?: string | undefined;
  readonly onSignIn: () => void;
}

export function SignIn({ reason, onSignIn }: SignInProps) {
  return (
    <main className="signin">
      <div className="signin__card">
        <h1 className="signin__title">Plan Forge</h1>
        <p className="signin__body">Sign in with your Audio Enhancement account to continue.</p>

        {reason !== undefined && (
          <p className="signin__problem" role="alert">
            {reason}
          </p>
        )}

        <button type="button" className="btn btn--primary signin__button" onClick={onSignIn}>
          Sign in
        </button>

        <p className="signin__hint">
          Access is granted by IT. If sign-in succeeds but the application refuses you, ask to
          be assigned to plan-forge.
        </p>
      </div>
    </main>
  );
}
